<template>
  <div class="above-the-fold">
    <div class="presentation">
      <div class="texts-container">
        <h1 class="name">{{ $t("presentation.title") }}</h1>
        <h2 class="description">{{ $t("presentation.description") }}</h2>
      </div>

      <div class="images-container">
        <img src="@/assets/angular.png" alt="" />
        <img src="@/assets/vue.png" alt="" />
        <img src="@/assets/ionic.png" alt="" />
        <img src="@/assets/react.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "AboveTheFold",
  components: {},
};
</script>
<style lang="scss" scoped>
div.above-the-fold {
  height: 100vh;
  font-family: "Raleway";

  div.presentation {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 80vh;
    padding: 2rem;

    h1.name {
      font-size: 2rem;
      font-weight: bold;
    }

    h2.description {
      font-size: 1rem;
      font-weight: 400;
      margin-top: 2rem;
    }

    div.images-container {
      img {
        height: 5rem;
        margin: 0.5rem;
      }
    }

    @media (min-width: 800px) {
      h1.name {
        font-size: 3rem;
      }

      h2.description {
        font-size: 2.5rem;
      }
    }
  }
}
</style>
